<template>
  <OneCTImage
    :image="{
      '@path': mgnlProps.image?.path ?? '',
    }"
    :title="mgnlProps.title"
    :title-color="mgnlProps.titleColor"
    :top-title="mgnlProps.topTitle"
    :top-title-color="mgnlProps.topTitleColor"
    :sub-text="mgnlProps.subText"
    :sub-text-color="mgnlProps.subTextColor"
    :cta-text="mgnlProps.ctaText"
    :cta-target-mode="mgnlProps.ctaTargetMode"
    :page-link="mgnlProps.pageLink"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { OneCTImageBuilder, WrapperProps } from './OneCTImage.model';
import OneCTImage from './OneCTImage.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';
import useTeaser from '~/composables/useTeaser/useTeaser';

const props = defineProps(WrapperProps);
const {
  topTitleColor, titleColor, subTextColor,
} = toRefs(props);

const { transformTeaserData } = useTeaser();

const mgnlProps = {
  ...transformTeaserData(OneCTImageBuilder.build(props)),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
  titleColor: magnoliaGetters.getHexColor(titleColor?.value),
  subTextColor: magnoliaGetters.getHexColor(subTextColor?.value),
};
</script>
